<template>
  <div class="dropdown-container">
    <p>{{ data.title }}</p>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

import { ISectionData } from '../types';

@Component({})
export default class DropdownSectionItem extends Vue {
  @Prop({ type: Object, required: true })
  private data!: ISectionData;
}
</script>

<style lang="less" scoped>
.dropdown-container {
  padding: @size-spacing-x400 @size-spacing-x300 @size-spacing-x300
    @size-spacing-x300;

  p {
    .text-p-6();
    font-weight: 600;
    color: @text-secondary;
  }
}
</style>
